// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import ReactOnRails from "react-on-rails";
import FindPhotosLanding from "../bundles/FindPhotosLanding";

// This is how react_on_rails can see the FindPhotosLanding in the browser.
ReactOnRails.register({
  FindPhotosLanding,
});
